import {  CommonState } from "../../../state/types"
import { MessagingState } from "../state/types"

export const messagingSelector = (state: CommonState): MessagingState =>
  state?.messaging
